import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import * as Sentry from '@sentry/react'
import { Analytics } from '@vercel/analytics/react'
import './styles/globals.css'
import './styles/animations.css'
import App from './App.jsx'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.PROD,
  sampleRate: 1.0,
  tracesSampleRate: 0,
  ignoreErrors: [
    'Network request failed',
    'NetworkError',
    'Failed to fetch',
    'Load failed',
    'net::ERR_',
    'paddle',
    'Paddle',
    '__paddle',
    'chrome-extension://',
    'moz-extension://',
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
  ],
  beforeSend(event) {
    const frames = event.exception?.values?.[0]?.stacktrace?.frames || []
    const fromPaddle = frames.some(f => f.filename?.includes('paddle'))
    if (fromPaddle) return null
    return event
  },
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <HelmetProvider>
      <App />
      <Analytics />
    </HelmetProvider>
  </StrictMode>,
)